import { WidgetInitContext, WidgetTypeEnum, TemplateParentTypeEnum } from '@/types';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument, isEmailTemplate, getWidgetType } from './helpers';

const widgetInitHandlers = new Map<WidgetTypeEnum, (ctx: WidgetInitContext) => void>();

// --- Enregistrement des handlers ---

// Countdown
widgetInitHandlers.set(WidgetTypeEnum.COUNTDOWN, (ctx) => {
  if (isEmailTemplate(ctx.templateType)) {
    import('@/components/template-builder/setters').then(({ initializeEmailCountdownWidget }) => {
      initializeEmailCountdownWidget(ctx.widget.id);
    });
  } else {
    import('@/components/template-builder/setters').then(({ startCountdownInterval }) => {
      startCountdownInterval(ctx.widget, `#${ctx.widget.id}`);
    });
  }
});

// Integration widget (generic declarative — image-as-a-service OR html render)
widgetInitHandlers.set(WidgetTypeEnum.INTEGRATION_WIDGET, (ctx) => {
  import('@/components/template-builder/setters').then(({ initializeIntegrationWidget }) => {
    initializeIntegrationWidget(ctx.widget.id, ctx.trigger);
  });
});

// --- API publique ---

/** Initialise un widget spécifique */
export const initWidget = (ctx: WidgetInitContext): void => {
  const widgetType = getWidgetType(ctx.widget.getAttribute('data-widgettype'));
  if (widgetType) {
    const handler = widgetInitHandlers.get(widgetType);
    if (handler) {
      handler(ctx);
    }
  }
};

/** Initialise tous les widgets du template qui ont un handler enregistré */
export const initAllWidgets = (trigger: WidgetInitContext['trigger'], templateType: TemplateParentTypeEnum): void => {
  const template = getTemplateIframeDocument();
  if (!template) return;

  const allWidgets = template.querySelectorAll('[data-widgettype]');
  allWidgets.forEach((el) => {
    const htmlEl = el as HTMLElement;
    const widgetType = getWidgetType(htmlEl.getAttribute('data-widgettype'));
    if (widgetType && widgetInitHandlers.has(widgetType) && htmlEl.id) {
      widgetInitHandlers.get(widgetType)!({ trigger, widget: htmlEl, templateType });
    }
  });
};

/** Permet d'enregistrer un handler depuis l'extérieur (pour de futures intégrations) */
export const registerWidgetInit = (type: WidgetTypeEnum, handler: (ctx: WidgetInitContext) => void): void => {
  widgetInitHandlers.set(type, handler);
};
